import API from 'api';
import { normalizeAction } from 'api/normalize';
import { ActionModel, ActionResponse, StandardThunkAction } from 'types';
import { Action, actionCreator } from 'util/actions';
import { createReducer } from 'util/reducers';

// Action types
import {
  LOAD_BOARD_SUCCESS,
  LOAD_HIGHLIGHT_ACTIONS_SUCCESS,
  LOAD_MEMBER_ACTIVITY_SUCCESS,
  LoadHighlightActionsSuccessAction,
} from 'modules/loaders';

export type ActionsState = ActionModel[];

const ADD_CARD_COMMENT = Symbol('models/ADD_CARD_COMMENT');
const DELETE_CARD_COMMENT = Symbol('models/DELETE_CARD_COMMENT');
const SET_COMMENT_TEXT = Symbol('models/SET_COMMENT_TEXT');

type AddCardCommentAction = Action<typeof ADD_CARD_COMMENT, ActionResponse>;
type DeleteCardCommentAction = Action<typeof DELETE_CARD_COMMENT, string>;
type SetCommentTextAction = Action<typeof SET_COMMENT_TEXT, ActionResponse>;

const addCardCommentAction = actionCreator<AddCardCommentAction>(
  ADD_CARD_COMMENT,
);
const deleteCardCommentAction = actionCreator<DeleteCardCommentAction>(
  DELETE_CARD_COMMENT,
);
const setCommentTextAction = actionCreator<SetCommentTextAction>(
  SET_COMMENT_TEXT,
);

const initialState: ActionsState = [];

export default createReducer(initialState, {
  // tslint:disable-next-line:no-any
  [LOAD_BOARD_SUCCESS](state, { payload }: any) {
    return [].concat(payload.actions).map((action) => normalizeAction(action));
  },

  // tslint:disable-next-line:no-any
  [LOAD_MEMBER_ACTIVITY_SUCCESS](state, { payload }: any) {
    return [].concat(payload.actions).map((action) => normalizeAction(action));
  },

  [LOAD_HIGHLIGHT_ACTIONS_SUCCESS](
    state,
    { payload }: LoadHighlightActionsSuccessAction,
  ) {
    const idActions = new Set(payload.map((action) => action.id));

    return [
      ...payload.map((action) => normalizeAction(action)),
      ...state.filter((action) => !idActions.has(action.id)),
    ];
  },

  [ADD_CARD_COMMENT](state, { payload }: AddCardCommentAction) {
    return [normalizeAction(payload), ...state];
  },

  [DELETE_CARD_COMMENT](state, { payload }: DeleteCardCommentAction) {
    return state.filter((action) => action.id !== payload);
  },

  [SET_COMMENT_TEXT](state, { payload }: SetCommentTextAction) {
    const { id, data } = payload;
    const text = data && data.text;

    return state.map(
      (action) => (action.id !== id ? action : { ...action, text }),
    );
  },
});

export const addCardComment = ({
  idCard,
  text,
}: {
  idCard: string;
  text: string;
}): StandardThunkAction<Promise<AddCardCommentAction | void>> => {
  return async (dispatch, getState) => {
    try {
      const action = await API.client.rest.post<ActionResponse>(
        `cards/${idCard}/actions/comments`,
        { query: { text } },
      );

      return dispatch(addCardCommentAction(action));
    } catch (err) {
      return Promise.reject(err);
    }
  };
};

export const deleteCardComment = (idAction: string): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      await API.client.rest.del(`actions/${idAction}`);

      dispatch(deleteCardCommentAction(idAction));
    } catch (err) {}
  };
};

export const setCommentText = ({
  idAction,
  text,
}: {
  idAction: string;
  text: string;
}): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      const action = await API.client.rest.put<ActionResponse>(
        `actions/${idAction}`,
      );

      dispatch(setCommentTextAction(action));
    } catch (err) {}
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/actions.ts